import PropTypes from 'prop-types';
import React from 'react';
import styles from './PayButton.module.scss';

const PayButton = React.forwardRef(
    (
        {
            hidePayButton,
            isLoading,
            lang,
            paymentPageURL = 'https://localhost:3006',
            paymentRequestId,
        },
        ref,
    ) => {
        React.useImperativeHandle(
            ref,
            () => ({
                pay() {
                    if (paymentRequestId && !isLoading) {
                        redirectToPaymentPage();
                    }
                },
            }),
            // eslint-disable-next-line react-hooks/exhaustive-deps
            [paymentRequestId, isLoading],
        );

        const redirectToPaymentPage = React.useCallback(() => {
            const url = new URL(`${paymentPageURL}/${paymentRequestId}`);

            if (lang) {
                url.searchParams.set('lng', lang);
            }
            try {
                window.top.location.href = url.href;
            } catch (e) {
                console.error(e);
                window.open(url.href, '_blank');
            }
        }, [paymentPageURL, paymentRequestId, lang]);

        return (
            <>
                {!hidePayButton && (
                    <button
                        disabled={isLoading}
                        className={styles.pay_button}
                        onClick={redirectToPaymentPage}>
                        {isLoading ? (
                            <span className={styles.loader}></span>
                        ) : (
                            <span>Pay</span>
                        )}
                    </button>
                )}
            </>
        );
    },
);

PayButton.propTypes = {
    hidePayButton: PropTypes.bool,
    isLoading: PropTypes.bool,
    lang: PropTypes.string,
    paymentPageURL: PropTypes.string,
    paymentRequestId: PropTypes.string,
};

export default PayButton;
